import axios from "axios";

var Benefit = {
  initializeHeaders: function (headers) {
    axios.defaults.headers.common = headers;
  },
    getFormulary: function (formulary_name) {
        return axios.get(
            Apollo.resolveApiUrl("~/benefit/formulary/" + formulary_name),
            {
            });
    },
  get: function () {
    return axios.get(
      Apollo.resolveApiUrl("~/benefit" ),
      {
      });
    }
};

export default Benefit;



// WEBPACK FOOTER //
// ./src/models/Benefit.js